import { useInfiniteQuery } from '@tanstack/react-query';

import { contentSelect, getNextPageRule } from '../utils/content';

import { fetchSection } from '@apis/uefatv';

/**
 * A React hook that fetches content for the UEFA TV section of the application and manages the infinite scroll functionality.
 *
 * @param section - The section of UEFA TV content to fetch.
 * @param logged - Whether the user is logged in or not.
 * @returns An object containing the fetched content data, a function to load more content, and loading state flags.
 */
export const useContent = (section: string, logged: boolean, bpp?: string, rpp?: string) => {
  const { data, isLoading, isFetched, isFetchingNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: ['uefatv-content', section, logged, bpp, rpp],
    queryFn: ({ pageParam, signal }) => fetchSection({ section, lastSeen: pageParam, bpp, rpp }, signal),
    select: contentSelect,
    initialPageParam: 'empty',
    getNextPageParam: getNextPageRule,
    enabled: !!section && !!logged,
  });

  return { data, loadMoreContent: fetchNextPage, isLoading, isFetched, isFetchingNextPage };
};
